import React, { lazy, Suspense } from 'react';

const LazyWeeklyDTRReport = lazy(async () => await import('./WeeklyDTRReport'));

const WeeklyDTRReport = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyWeeklyDTRReport {...props} />
  </Suspense>
);

export default WeeklyDTRReport;
